// Module
var code = "<div class=\"container\"> <div class=\"row center-block text-center\"> <h3>Success!</h3> <a ui-sref=\"login\"><button type=\"submit\" class=\"btn btn-primary\">Click to Login</button> </a></div> </div>";
// Exports
module.exports = code;